import React, { useEffect, useState } from "react";
import { Box, Button } from "digiwash-components";
import Modal from "../ReactNativeModal";
import BoxRatio from "../BoxRatio";
import { boxRatioWidth } from "../../helpers/general";
import dayjs from "dayjs";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Image } from "react-native";

interface PropsType {
  url: string;
}

function Popup(props: PropsType) {
  let currentTime = Date.now();
  let [visiblePopup, setVisiblePopup] = useState<boolean>();
  let [time, setTime] = useState<string>();
  AsyncStorage.getItem("time").then((res) => {
    setTime(res);
  });
  let diff = dayjs(currentTime).diff(dayjs(Number(time)), "hours");

  useEffect(() => {
    if (diff >= 12) {
      setVisiblePopup(true);
    }
  }, [diff]);
  return (
    <Modal
      isVisible={visiblePopup}
      style={{
        justifyContent: "center",
        margin: 0,
        width: "100%",
        alignItems: "center",
      }}
    >
      <Box
        p="l"
        style={{
          width: "100%",
          maxWidth: 720,
        }}
        br="l"
      >
        <BoxRatio ratio="2:0.7" fixedWidth={boxRatioWidth({ columns: 1 })}>
          <Image
            resizeMode="contain"
            source={{ uri: `${props.url}` }}
            style={{ width: "100%", height: "100%" }}
          />
        </BoxRatio>
      </Box>

      <Button
        onPress={() => {
          setVisiblePopup(false);
          AsyncStorage.setItem("time", `${currentTime}`);
        }}
      >
        متوجه شدم
      </Button>
    </Modal>
  );
}

export default Popup;
